import { useState } from "react";

const ServiceStatusWidget = () => {
  // The Freshstatus badge is an external image and has been seen to 404 (the
  // badge id stopped resolving). A dropdown row must never show a broken
  // image, so when it fails we fall back to a plain labeled row that matches
  // the other menu items; the row's status-page link keeps working either way.
  const [badgeFailed, setBadgeFailed] = useState(false);
  if (badgeFailed) {
    // no .status-badge-container here: that wrapper is height:23px with
    // overflow:hidden, sized for the badge image - it clips a text row.
    // Sibling menu rows are bare fragments inside the flex item, so the
    // fallback is one too.
    return (
      <>
        <svg className="nav-icon" viewBox="0 0 16 16" aria-hidden="true">
          <circle cx="8" cy="8" r="4" fill="#00805e" />
          <circle
            cx="8"
            cy="8"
            r="6.5"
            fill="none"
            stroke="#00805e"
            strokeOpacity="0.35"
            strokeWidth="1.5"
          />
        </svg>
        <span>Service Status</span>
      </>
    );
  }
  return (
    <div className="status-badge-container">
      <img
        src="https://public-api.freshstatus.io/v1/public/badge.svg/?badge=b933f303-5116-44fb-9600-70a7242eec25"
        alt="Service Status"
        onError={() => setBadgeFailed(true)}
      />
    </div>
  );
};
export default ServiceStatusWidget;
